import GPDto from "../Geschaeftspartner/GPDto";
import BenutzerDto from "../Benutzer/BenutzerDto";

export default class ZVVDto {
  constructor(json) {
    if (json) {
      this.extId = json.extId
      this.name = json.name
      this.telefon = json.telefon
      this.verantwortlicherBenutzer = new BenutzerDto(json.verantwortlicherBenutzer)
      this.koordinierenderBenutzer = new BenutzerDto(json.koordinierenderBenutzer)
      this.geschaeftspartner = new GPDto(json.geschaeftspartner)
      this.isAktiveKontingentierung = json.isAktiveKontingentierung
    }
  }
}
